import { reservesConfig } from '../../../../config';
import { http } from '../../../../api/axios';
import { ReserveListCheckoutOut } from '../../../../store/api';

export const fetchMeta = (reserveListId): Promise<ReserveListCheckoutOut> => {
    return http
        .get(reservesConfig().endpointReserveCheckoutMeta, { pathParams: { reserveListId } })
        .then(res => res.data);
};
